
import React, { useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../constant/api";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(""); // clear previous errors

    try {
      const res = await axios.post(
        `${BASE_URL}/accounts/admin/contact-us/`,
        formData
      );
      console.log("Response:", res.data);
      // alert("Message sent successfully!");
      setFormData({
        first_name: "",
        last_name: "",
        email: "",
        subject: "",
        message: "",
      });
    } catch (err) {
      console.error("Error:", err);
      if (err.response && err.response.data) {
        setError(err.response.data.message || "Something went wrong.");
      } else {
        setError("Network error. Please try again.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="border border-brand-primary flex flex-col justify-center items-center w-full py-20 rounded-xl">
      <h2 className="text-3xl sm:text-5xl text-center font-bold mb-10">
        Get in Touch with Our Team
      </h2>
      <form
        className="w-full p-2 md:w-1/2 mt-5"
        onSubmit={handleSubmit}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          <input
            type="text"
            name="first_name"
            placeholder="FIRST NAME"
            value={formData.first_name}
            onChange={handleChange}
            className="border border-gray-200 p-4 rounded focus:outline-none focus:ring-1 focus:ring-gray-300"
            required
          />
          <input
            type="text"
            name="last_name"
            placeholder="LAST NAME"
            value={formData.last_name}
            onChange={handleChange}
            className="border border-gray-200 p-4 rounded focus:outline-none focus:ring-1 focus:ring-gray-300"
            required
          />
          <input
            type="email"
            name="email"
            placeholder="EMAIL"
            value={formData.email}
            onChange={handleChange}
            className="border border-gray-200 p-4 rounded focus:outline-none focus:ring-1 focus:ring-gray-300"
            required
          />
          <input
            type="text"
            name="subject"
            placeholder="SUBJECT"
            value={formData.subject}
            onChange={handleChange}
            className="border border-gray-200 p-4 rounded focus:outline-none focus:ring-1 focus:ring-gray-300"
            required
          />
          <textarea
            name="message"
            placeholder="MESSAGE"
            value={formData.message}
            onChange={handleChange}
            className="border border-gray-200 p-3 rounded focus:outline-none focus:ring-1 focus:ring-gray-300 h-56 md:col-span-2"
            required
          />
        </div>

        {error && <p className="text-red-500 mt-4">{error}</p>}

        <button
          type="submit"
          disabled={submitting}
          className={`my-10 text-brand-primary border border-brand-primary w-full p-4 rounded hover:bg-brand-primary hover:text-white transition duration-300 ${
            submitting ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          {submitting ? "Submitting..." : "SUBMIT"}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
